module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_09.d9810713.jpg";